<template>
  <div class="grid md:grid-cols-4 gap-4">

    <div class="flex">

      <ARadioGroup :value="cr" v-model="cr" class="ml-4" v-if="!isFirst" @change="change">
        <ARadioButton value="and">و</ARadioButton>
        <ARadioButton value="or">یا</ARadioButton>
      </ARadioGroup>
      <ASelect class="flex-1" @change="change" v-model="col" placeholder="عنوان ستون">
        <ASelectOption :value="item.key" :key="index" v-for="(item, index) in colFilters">
          {{
            item.title
          }}
        </ASelectOption>
      </ASelect>
    </div>
    <ASelect :disabled="!col" placeholder="عملگر" v-model="op" @change="change">
      <ASelectOption :value="index" :key="index" v-for="(item, index) in colTypes">
        {{
          item
        }}
      </ASelectOption>
    </ASelect>
    <div v-if="type && hasInput">
      <component
        @input="change"
        :is="getModifierComponent"
        :items="filterObject.filterItems"
        :action="filterObject.filterAction"
        v-model="input"
      />
    </div>
    <div>
      <feather-icon icon="XIcon" class="cursor-pointer" svg-classes="text-danger" @click="$emit('remove', index)"/>
    </div>
  </div>
</template>

<script>
import NumberXTableFilter from "./NumberXTableFilter";
import SwitchXTableFilter from './SwitchXTableFilter'
import SelectOptionXTableFilter from './SelectOptionXTableFilter'
import DateXTableFilter from './DateXTableFilter'
import TextXTableFilter from './TextXTableFilter'
import QuerySelectTableFilter from './QuerySelectTableFilter'

export default {
  name: "XFilterRow",
  components: {
    NumberXTableFilter,
    SwitchXTableFilter,
    SelectOptionXTableFilter,
    QuerySelectTableFilter,
    DateXTableFilter,
    TextXTableFilter,
  },
  props: {
    value: {default: {}},
    isFirst: {default: false},
    id: {},
    index: {},
    colFilters: {default: []}
  },
  data() {
    return {
      col: undefined,
      op: undefined,
      master: undefined,
      cr: 'and',
      input: undefined,
    }
  },
  computed: {
    hasInput() {
      if (this.op) {
        return !['null', 'nn'].includes(this.op);
      }
    },
    getModifierComponent() {
      const comp = {
        'text': 'TextXTableFilter',
        'default': 'TextXTableFilter',
        'number': 'NumberXTableFilter',
        'date': 'DateXTableFilter',
        'switch': 'SwitchXTableFilter',
        'select': 'SelectOptionXTableFilter',
        'query': 'QuerySelectTableFilter',
      };
      return comp[this.type];
    },
    getModel() {

      return {
        cr: this.cr,
        index: this.index,
        field: this.col,
        master: this.master,
        type: this.type,
        id: this.id,
        op: this.op,
        value: this.input
      }
    },
    filterObject() {
      return this.colFilters.find((item) => item.key == this.col);
    },
    type() {
      if (this.filterObject) {
        return this.filterObject.filterType;
      }
    },
    colTypes() {
      const exp = {};
      if (!this.col) return [];
      const filter = this.colFilters.find((item) => item.key == this.col);
      if (!filter) return [];

      switch (filter.filterType) {
        case 'number':
        case 'date':
          exp.gt = 'بزرگتر';
          exp.lt = 'کوچکتر';
          exp.gte = 'بزرگتر مساوی';
          exp.lte = 'کوچکتر مساوی';
          // exp.bet = 'بین';
          break;
        case 'text':
          exp.sw = 'شروع شود';
          exp.ew = 'تمام شود';
          break;
      }

      exp.eq = 'برابر';
      exp.has = 'شامل';
      exp.not = 'نباشد';
      exp.null = 'تهی';
      exp.nn = 'تهی نباشد';

      return exp;
    }
  },
  methods: {
    change() {
      const filter = this.colFilters.find((item) => item.key == this.col);
      this.master = filter.master;
      this.$emit('input', this.getModel);
    }
  },
  mounted() {
    this.cr = this.value.cr || 'and';
    // this.index = this.value.index;
    console.log("this.value.field ==> ", this.value);
    this.col = this.value.field;
    // this.type = this.value.type;
    this.op = this.value.op;
    this.input = this.value.value;
  }
}
</script>

<style scoped>

</style>
